import { styled } from '@nykaa/ui-components';

export const WidgetsContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  padding-bottom: 20px;
`;
